/**
 * The shell's German (`de`) shell baseline, composed from per-feature fragments —
 * the German mirror of `baseEn` (which is Grymwyrd's English voice). Because the
 * baseline IS Grymwyrd's copy, `baseDe` IS Grymwyrd's German; other worlds (e.g.
 * Zweihänder) inherit the generic German here and override only their flavor keys
 * in their own `WorldConfig.content.de`.
 *
 * Agent-generated in P-D (informal "du", idiomatic native German). **Pending a
 * native-speaker review pass before launch** (per the i18n plan).
 */
import { layoutDe } from './de/layout'
import { homeDe } from './de/home'
import { playDe } from './de/play'
import { demoDe } from './de/demo'
import { booksDe } from './de/books'
import { commerceDe } from './de/commerce'
import { communityDe } from './de/community'
import { dashboardDe } from './de/dashboard'
import { authDe } from './de/auth'
import { marketingDe } from './de/marketing'
import { worldDe } from './de/world'
import { encyclopediaDe } from './de/encyclopedia'
import { systemDe } from './de/system'
import { cityDe } from './de/city'
import type { MessageCatalog } from '@gamecodex/world-config'

export const baseDe: MessageCatalog = {
  ...layoutDe,
  ...homeDe,
  ...playDe,
  ...demoDe,
  ...booksDe,
  ...commerceDe,
  ...communityDe,
  ...dashboardDe,
  ...authDe,
  ...marketingDe,
  ...worldDe,
  ...encyclopediaDe,
  ...systemDe,
  ...cityDe,
}
